import { useOutletContext } from 'react-router-dom';
import ErrorBreakdown from './components/ErrorBreakdown';

const ErrorsTab = () => {
  const { top_errors } = useOutletContext();
  return <ErrorBreakdown data={top_errors} />;
};

export default ErrorsTab;
